import api from './api';
import { downloadBinaryFile } from './fileDownload';

const incomingEmailService = {
  getAll: async (filters = {}, pagination = {}) => {
    const params = new URLSearchParams();
    Object.entries(filters).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== '') params.append(key, value);
    });
    if (pagination.page) params.append('page', pagination.page);
    if (pagination.limit) params.append('limit', pagination.limit);

    const response = await api.get(`/incoming-emails?${params.toString()}`);
    return response.data;
  },

  getById: async (id) => {
    const response = await api.get(`/incoming-emails/${id}`);
    return response.data;
  },

  markReviewStatus: async (id, status) => {
    const response = await api.patch(`/incoming-emails/${id}/review`, { status });
    return response.data;
  },

  convertToTicket: async (id, payload) => {
    const response = await api.post(`/incoming-emails/${id}/convert`, payload);
    return response.data;
  },

  downloadAttachment: async (id, attachmentIndex, fileName = null) => {
    return downloadBinaryFile(
      api,
      `/incoming-emails/${id}/attachments/${attachmentIndex}`,
      fileName || `incoming-email-${id}-attachment-${attachmentIndex + 1}`
    );
  },

  sendResolutionEmail: async (ticketId, payload) => {
    const response = await api.post(`/incoming-emails/tickets/${ticketId}/send-resolution-email`, payload);
    return response.data;
  },

  // NEW: Reply to email
  replyToEmail: async (id, payload) => {
    const response = await api.post(`/incoming-emails/${id}/reply`, payload);
    return response.data;
  },

  // NEW: Link email to existing ticket
  linkToTicket: async (id, ticketId) => {
    const response = await api.post(`/incoming-emails/${id}/link`, { ticket_id: ticketId });
    return response.data;
  },

  // NEW: Get emails linked to a ticket
  getEmailsByTicket: async (ticketId) => {
    const response = await api.get(`/incoming-emails/ticket/${ticketId}`);
    return response.data;
  },

  // NEW: Manual sync from mailbox
  syncFromMailbox: async () => {
    const response = await api.get(`/incoming-emails/sync`);
    return response.data;
  },

  // NEW: Hide email locally (from system UI only)
  hideLocally: async (id) => {
    const response = await api.post(`/incoming-emails/${id}/hide`);
    return response.data;
  },

  // NEW: Restore hidden email locally
  restoreLocally: async (id) => {
    const response = await api.post(`/incoming-emails/${id}/restore`);
    return response.data;
  },

  // NEW: Get hidden/deleted-local emails
  getHiddenEmails: async (pagination = {}) => {
    const params = new URLSearchParams();
    if (pagination.page) params.append('page', pagination.page);
    if (pagination.limit) params.append('limit', pagination.limit);

    const response = await api.get(`/incoming-emails/hidden?${params.toString()}`);
    return response.data;
  }
};

export default incomingEmailService;
